import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';

import {
  creditDialogAtom,
  initialCreditDialogState,
} from '@/atoms/creditDialogAtom';

import type { DownloadCredit, LicenseInfo } from '@/atoms/creditDialogAtom';
import type { Track } from '@/types/tracks';

export interface OpenCreditDialogParams {
  /** All download events for this track, newest first. Omit for single downloads. */
  downloads?: DownloadCredit[];
  licenseInfo: LicenseInfo;
  showWarning?: boolean;
  track: Track;
}

export const useCreditDialogOpen = (): boolean =>
  useAtomValue(creditDialogAtom).isOpen;

export const useCreditDialogActions = () => {
  const setDialogState = useSetAtom(creditDialogAtom);

  const open = useCallback(
    ({
      track,
      licenseInfo,
      downloads = [],
      showWarning = false,
    }: OpenCreditDialogParams) => {
      setDialogState({
        isOpen: true,
        track,
        licenseInfo,
        downloads,
        selectedDownloadIndex: 0,
        showWarning,
      });
    },
    [setDialogState]
  );

  const close = useCallback(() => {
    setDialogState(initialCreditDialogState);
  }, [setDialogState]);

  return { open, close };
};
